/**
 * Titan13 — Alt-based color swatches
 * Color is applied via CSS var(--titan-bg) set inline in Liquid,
 * so it is server-rendered and needs no JS to paint.
 * This script only marks sold-out state as a safety net and
 * re-inits on theme-editor section reload.
 */
(function () {
  'use strict';

  function initSwatches(root) {
    var scope = root || document;

    // Mark sold-out swatches (server already renders the class; this is a fallback)
    scope.querySelectorAll('.titan-color-swatch').forEach(function (wrapper) {
      var input = wrapper.closest('.variant-option__button-label')
        ? wrapper.closest('.variant-option__button-label').querySelector('input[type="radio"]')
        : null;
      var dot = wrapper.querySelector('.titan-swatch__dot');
      if (input && dot && input.classList.contains('disabled')) {
        dot.classList.add('titan-swatch--sold-out');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSwatches(); });
  } else {
    initSwatches();
  }

  // Re-init on theme editor section reload
  document.addEventListener('shopify:section:load', function (e) {
    initSwatches(e.target);
  });
})();
